import { render, staticRenderFns } from "./araporcei.vue?vue&type=template&id=84fa50c2"
import script from "./araporcei.vue?vue&type=script&lang=js"
export * from "./araporcei.vue?vue&type=script&lang=js"
import style0 from "./araporcei.vue?vue&type=style&index=0&id=84fa50c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports